import { SceneConfig } from "../lib/types";

export const newDemoConfig: SceneConfig[] = [
  // ── S04: 步骤清单 — 逐项飞入 ──
  {
    sceneId: "S04",
    durationInFrames: 90,
    preset: "StepList.flyIn",
    props: {
      steps: ["写剧本", "选组件", "调 JSON", "出大片"],
    },
  },
  // ── S05: 推文卡片 — 3D 翻转 ──
  {
    sceneId: "S05",
    durationInFrames: 120,
    preset: "TweetCard.flip3D",
    props: {
      author: "Remotion",
      content: "Your UI = f(Data). One person = a film studio.",
    },
  },
  // ── S03-Glitch: SmashText 故障抖动 ──
  {
    sceneId: "S03-Glitch",
    durationInFrames: 90,
    preset: "SmashText.glitch",
    props: {
      mainText: "告别拖拽",
      subText: "AI 时代已来",
      highlight: ["告别"],
    },
  },
  // ── S07-B: AutoCaption 逐字高亮字幕 ──
  {
    sceneId: "S07-B",
    durationInFrames: 90,
    preset: "AutoCaption.wordHighlight",
    props: {
      text: "全 JSON 驱动，改稿不再求人！",
    },
  },
  // ── S02-B: CaptionRow 逐字缩放弹出 ──
  {
    sceneId: "S02-B",
    durationInFrames: 60,
    preset: "CaptionRow.scalePerWord",
    props: {
      text: "效率提升 100 倍",
    },
  },
  // ── S09: StepList 底部滑入 ──
  {
    sceneId: "S09",
    durationInFrames: 120,
    preset: "StepList.slideUp",
    props: {
      steps: ["填表格", "跑脚本", "收大片"],
    },
  },
  // ── S08: SmashText drop ──
  {
    sceneId: "S08",
    durationInFrames: 120,
    preset: "SmashText.drop",
    props: {
      mainText: "开始创作",
      subText: "你的第一个 AI 视频",
      highlight: ["创作"],
    },
  },
];
;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
